<div class="gapps-footer">
  <ng-container *ngIf="systemInfo$ | async as systemInfo">
    <img *ngIf="systemInfo.LogoUrl"
         [src]="systemInfo.LogoUrl"
         class="gapps-footer-logo"
         alt="logo">
  </ng-container>
</div>
